<script>
  import {
    addBlockedUser,
    setStickyComment,
    deleteComment,
    publishComment,
  } from '../../../Api/api';
  import { formatShortDate, getTime, isToday } from '../../../common/dates';
  import { firebaseApp } from '../../../Store/store';
  import { containsLink, setLink } from '../../../common/utils.js';
  import ActionMenu from '../../Common/ActionMenu/ActionMenu.svelte';
  import ActionMenuItem from '../../Common/ActionMenu/ActionMenuItem.svelte';

  export let thread = [];
  export let minWidth640 = false;
  export let currentId = '';

  const onPublishCommentClicked = async (comment) => {
    // Get timestamp when moderator publishes the message to show last in the chat
    const updatedComment = {
      ...comment,
      ignore: false,
      created: $firebaseApp.serverTimestamp,
    };
    await publishComment(currentId, updatedComment);
  };

  const onToggleStickyCommentClicked = async (comment) => {
    await setStickyComment(currentId, comment.commentId, !comment.sticky);
  };

  const onDeleteCommentClicked = async (comment) => {
    await deleteComment(currentId, comment.commentId);
  };
</script>

<div class="comments-list">
  {#each thread as comment}
    <div class="comment">
      {#if minWidth640}
        <span class="time-stamp"
          >{isToday(comment.created.toDate())
            ? getTime(comment.created.toDate())
            : formatShortDate(comment.created.toDate())}</span
        >
        <span class="content">
          {#if containsLink(comment.content)}
            {@html setLink(comment.content)}
          {:else}{comment.content}{/if}</span
        >
        <div class="user-name">
          <ActionMenu
            title={comment.userName}
            titleStyle="border-bottom: 1px solid #bbbec3;"
            fontSize="12"
            fontWeight="500"
            color="#bbbec3"
            minWidth="100"
          >
            <ActionMenuItem
              title="Blokker bruker"
              on:click={() =>
                addBlockedUser({
                  id: comment.userId,
                  userName: comment.userName,
                })}
            />
          </ActionMenu>
        </div>
        <button
          class="sticky-btn"
          title="Merk kommentar"
          class:on={comment.sticky}
          on:click={() => onToggleStickyCommentClicked(comment)}
          ><span class="material-icons">verified</span>
        </button>
        <button
          class="delete-btn"
          title="Fjern kommentar"
          on:click={() => onDeleteCommentClicked(comment)}
          ><span class="material-icons"> block </span>
        </button>
        <button
          class="ok-btn"
          title="Publiser kommentar"
          on:click={() => onPublishCommentClicked(comment)}
          ><span class="material-icons"> done </span>
        </button>
        {#if comment.ignore}
          <div class="rejected-msg">
            <span class="material-icons icon"> person_remove </span>
            <span>Avvist</span>
          </div>
        {/if}
      {:else}
        <div class="top">
          <span class="time-stamp">{getTime(comment.created.toDate())}</span>
          <div class="user-name">
            <ActionMenu
              title={comment.userName}
              titleStyle="text-decoration: underline;"
              fontSize="12"
              fontWeight="500"
              color="#bbbec3"
              minWidth="100"
            >
              <ActionMenuItem
                title="Blokker bruker"
                on:click={() =>
                  addBlockedUser({
                    id: comment.userId,
                    userName: comment.userName,
                  })}
              />
            </ActionMenu>
          </div>
          <div class="mod-btn-container">
            <button
              class="sticky-btn"
              title="Merk kommentar"
              class:on={comment.sticky}
              on:click={() => onToggleStickyCommentClicked(comment)}
              ><span class="material-icons">verified</span>
            </button>
            <button
              class="delete-btn"
              title="Fjern kommentar"
              on:click={() => onDeleteCommentClicked(comment)}
              ><span class="material-icons"> block </span>
            </button>
            <button
              class="ok-btn"
              title="Publiser kommentar"
              on:click={() => onPublishCommentClicked(comment)}
              ><span class="material-icons"> done </span>
            </button>
            {#if comment.ignore}
              <div class="rejected-msg">
                <span class="material-icons icon"> person_remove </span>
              </div>
            {/if}
          </div>
        </div>

        <div class="content">
          {#if containsLink(comment.content)}
            {@html setLink(comment.content)}
          {:else}{comment.content}{/if}
        </div>
      {/if}
    </div>
  {/each}
</div>

<style src="./comments.scss"></style>
